var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BTN/30/Line/Purple/Info/Nor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 3.9,
    y: 3.9,
    width: 22.2,
    height: 22.2,
    rx: 11.1,
    stroke: "#6931E0",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7253 11.719C15.5422 11.9063 15.3004 12 15 12C14.6996 12 14.4578 11.9063 14.2747 11.719C14.0916 11.5316 14 11.2941 14 11.0065C14 10.7146 14.0936 10.4739 14.2809 10.2843C14.4681 10.0948 14.7078 10 15 10C15.2922 10 15.5319 10.0948 15.7191 10.2843C15.9064 10.4739 16 10.7146 16 11.0065C16 11.2941 15.9084 11.5316 15.7253 11.719ZM15 13C14.4477 13 14 13.4477 14 14V19C14 19.5523 14.4477 20 15 20C15.5523 20 16 19.5523 16 19V14C16 13.4477 15.5523 13 15 13Z",
    fill: "#6931E0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.d73f56909f7f69463069be7d55540590.svg";
export { ForwardRef as ReactComponent };